// extracted by css-extract-rspack-plugin
export default {"loading":"loading--asbCoxl1hosgsI1h"};